import { ReactNode, useCallback } from 'react';
import { lighten, Button } from '@mui/material';

interface ToggleButtonProps {
  children?: ReactNode;
  value: string | boolean;
  onClick: (value: string | boolean) => void;
  selected: boolean;
  fitToContent?: boolean;
}

export const ToggleButton = ({
  value,
  onClick,
  selected,
  children,
  fitToContent,
  ...rest
}: ToggleButtonProps) => {
  const handleClick = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  return (
    <Button
      onClick={handleClick}
      sx={({ palette }) => ({
        backgroundColor: selected ? lighten(palette.primary.main, 0.8) : 'transparent',
        // textShadow used instead of fontWeight for active state.
        // The problem and the solution described here:
        // https://www.sitepoint.com/quick-tip-fixing-font-weight-problem-hover-states/
        textShadow: selected ? '0.5px 0' : 'none',
        fontWeight: 400,
        px: 2,
        height: '56px',
        textTransform: 'capitalize',
        letterSpacing: 0,
        lineHeight: 1.1,
        ...(fitToContent ? { flex: 'none', whiteSpace: 'nowrap', minWidth: 'auto' } : { flex: 1 }),
        '&:hover': {
          backgroundColor: lighten(palette.primary.main, 0.8),
        },
      })}
      variant='outlined'
      {...rest}
    >
      {children}
    </Button>
  );
};
